<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="科目">
                  <el-input  v-model="queryForm.subjectName"></el-input>
              </el-form-item>
              <el-form-item label="父级科目">
                  <el-input  v-model="queryForm.parentId"></el-input>
              </el-form-item>
              <el-form-item label="排序">
                  <el-input  v-model="queryForm.sort"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduSubjectList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduSubject"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduSubject(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduSubject(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
<!--            <el-upload v-if="this.isImportDate"-->
<!--              class="upload-demo"-->
<!--              action="#"-->
<!--                            :http-request="upload"-->
<!--              :show-file-list="true">-->
<!--              <el-button size="small" type="primary">点击上传</el-button>-->
<!--              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>-->
<!--            </el-upload>-->
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduSubjectList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduSubjectList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduSubjectList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="subjectName"
        label="科目"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="父级科目"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduSubject(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduSubject(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduSubject(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
              <div @click="addChildCourseCategory(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">添加下级分类</span>
              </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
<!--    <div class="pagination-box">-->
<!--      <el-pagination-->
<!--        @size-change="sizeChange"-->
<!--        @current-change="currentChange"-->
<!--        :current-page.sync="currentPage"-->
<!--        :page-sizes="[10, 20, 50, 100]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="totalNum"-->
<!--        background-->
<!--        :pager-count="7"-->
<!--      >-->
<!--      </el-pagination>-->
<!--    </div>-->
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduSubjectStates[eduSubjectState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduSubject"
          ref="eduSubjectForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="科目"
            prop="subjectName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduSubject.subjectName"
              :disabled="eduSubjectState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="父级科目"
            prop="parentId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduSubject.parentId"-->
<!--              :disabled="eduSubjectState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  :disabled="eduSubjectState == 'check'"
                  v-model="eduSubject.parentId"
                  placeholder="请选择"
                  size="small"
              >
                  <el-tree
                      :data="eduSubjectList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduSubject.sort"-->
<!--              :disabled="eduSubjectState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduSubjectState == 'check'"
                  v-model="eduSubject.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduSubjectState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduSubjectList();
                    this.getEduSubjectList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduSubjectList();
                    this.getEduSubjectList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     subjectName: '', //科目
                     parentId: '', //父ID
                     sort: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 1,
                currentUserId: '',
                eduSubjectState: 'add',
                eduSubjectStates: {
                    add: '新建科目',
                    check: '查看科目',
                    edit: '修改科目'
                },
                treeProps: {
                    children: 'children',
                    label: 'subjectName'
                },
                multipleSelection: [],
                eduSubjectList: [],
                eduSubject: {
                    id: '', //
                    subjectName: '', //科目
                    parentId: '', //父ID
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    subjectName: [{ required: true, message: '科目不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getEduSubjectList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            addChildCourseCategory(id){
                this.addEduSubject()
                this.eduSubject.parentId = id
            },
            resetEduSubjectList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduSubjectList = [];
            },
            resetDialog() {
                this.eduSubjectState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      subjectName: '', //科目
                      parentId: '', //父ID
                      sort: '', //排序
                };
                this.getEduSubjectList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduSubject = {
                      id: '', //
                      subjectName: '', //科目
                      parentId: '', //父ID
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduSubjectState == 'add') {
                    this.$refs.eduSubjectForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/subject/add`,{ ...this.eduSubject }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduSubjectList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduSubjectState == 'edit') {
                    this.$refs.eduSubjectForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduSubject.children;
                            post(`/edu/subject/edit`,{ ...this.eduSubject }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduSubjectList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduSubject() {
                this.showDialog = true;
                this.eduSubjectState = 'add';
            },
            checkEduSubject(eduSubjectId) {
                console.log(eduSubjectId);
                this.currentEduSubjectId = eduSubjectId;

                this.getEduSubjectById();
                this.showDialog = true;
                this.eduSubjectState = 'check';
            },
            editEduSubject(eduSubjectId) {
                console.log('eduSubject', eduSubjectId);
                if (eduSubjectId) {
                    this.currentEduSubjectId = eduSubjectId;
                    this.getEduSubjectById();
                } else {
                    this.eduSubject = { ...this.eduSubject, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduSubjectState = 'edit';
            },
            deleteEduSubject(eduSubjectId) {
                let ids = '';
                if (eduSubjectId) {
                    ids = eduSubjectId;
                } else {
                    ids = this.multipleSelection.map((eduSubject) => eduSubject.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/subject/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduSubjectList();
                                this.getEduSubjectList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduSubjectList() {
                this.resetEduSubjectList();
                this.getEduSubjectList();
            },
            getEduSubjectList(query = {}) {
                this.loading = true;
                get(`/edu/subject/findAllAsTree`,{  ...this.queryForm }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduSubjectList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduSubjectById() {
                get(`/edu/subject/get`,{ id: this.currentEduSubjectId }).then((res) =>{
                    if(res.success){
                      this.eduSubject = { ...this.eduSubject, ...res.eduSubject };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduSubjectList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/subject/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/subject/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/subject/importData`,formData);
              this.refreshEduSubjectList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduSubjectList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduSubjectList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>